import React from 'react'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { colors } from '@mobi/component-library/Foundations'
import { doesClientSupportShare } from '@core/Areas/ShareBet/helpers/doesClientSupportShare'
import { openShareOutgoing } from '@core/Areas/ShareBet/ShareBetOutgoing/helpers/emitter'
import { ReceiptButtonStyled } from '@core/Areas/Quickbet/Components/Receipt/Components/Common/Receipt.styles'
import {
  ShareToBetLoopTooltip,
  useShareToBetLoopTooltip,
} from '@core/Areas/BetLoop/hooks/useShareToBetLoopTooltip'

const enum LocalConstants {
  ShareButtonSeenCountStorageKey = 'betloop:quickbet-kambi-share-tooltip-count',
}

export const ShareButton: React.FC<{ coupon: Readonly<KambiHistoryCoupon> }> = ({ coupon }) => {
  if (!doesClientSupportShare()) return null

  return <ShareButtonComponent coupon={coupon} />
}

// ===============
// Local Component
// ===============

const ShareButtonComponent: React.FC<{ coupon: Readonly<KambiHistoryCoupon> }> = ({ coupon }) => {
  const { shareButtonRef, onShareButtonClick, handleDismissShareTooltip, isShareTooltipVisible } =
    useShareToBetLoopTooltip(LocalConstants.ShareButtonSeenCountStorageKey)

  const handleShareBetClick = () => {
    onShareButtonClick()
    openShareOutgoing({ contextType: 'kambi', share: { coupon } })
  }

  return (
    <>
      <ReceiptButtonStyled
        onClick={handleShareBetClick}
        color='secondary'
        type='button'
        role='button'
        ref={shareButtonRef}
      >
        <Icon name='LineShare02' color={colors.black} /> Share My Bet
      </ReceiptButtonStyled>

      {isShareTooltipVisible && (
        <ShareToBetLoopTooltip
          triggerElRef={shareButtonRef}
          onDismissed={handleDismissShareTooltip}
        />
      )}
    </>
  )
}
